import {ajax} from '../utils/ajaxHelper';

function getReviews({
    listingId,
    site,
    siteLanguage,

    formattedLocale,
    page,
    reviewPageSize,
    filter,
    sort
}) {
    const filterParam = filter ? `&${filter}` : '';
    const sortParam = sort ? `&sortBy=${sort}` : '';
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarkerParam = requestMarker ? `&requestMarker=${requestMarker}` : '';
    const variantParam = variant ? `&variant=${variant}` : '';

    const url = `/pdp/reviews?listingId=${listingId}&site=${site}&siteLanguage=${siteLanguage}&localeFormatted=${formattedLocale}&page=${page}&pageSize=${reviewPageSize}${filterParam}${sortParam}${variantParam}${requestMarkerParam}`;
    // Consider handling the ajax callback here, and mutating the data to something standard.
    return ajax(url);
}

export default getReviews;
export {getReviews};
